import { FC, ReactElement } from 'react';
import { BorderedStatusIcon, cn, TStatus } from '@fe-learner-common';

type ErrorMessageProps = {
  className?: string;
  action?: ReactElement;
  status: TStatus;
  texts: {
    title: string;
    description: string;
  };
};

export const FeedbackMessage: FC<ErrorMessageProps> = ({
  className,
  texts,
  action,
  status,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-6 py-[100px]',
        className,
      )}
    >
      <BorderedStatusIcon status={status} />
      <h2 className="pt-4 text-headline-md">{texts.title}</h2>
      <p className="whitespace-pre-line pt-2 text-center text-body-md text-neutral-500">
        {texts.description}
      </p>
      {action && <div className="pt-4">{action}</div>}
    </div>
  );
};
